import {
  FaInstagram,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneSquare,
  FaFacebook
} from 'react-icons/fa'

import * as S from '../../components/Contato/styles'

import * as Global from '../../styles/index'
import * as Txt from '../../styles/text'
import { ConstruindoContainer, Logo } from './styles'

const Construindo = () => {
  return (
    <>
      <ConstruindoContainer>
        <Global.Container>
          <Logo
            src="https://static-file-vault.vercel.app/cdtchechela/logo_cdtcc.svg"
            alt="logo"
          />
          <h2>Site em Desenvolvimento</h2>
          <S.Container id="contato">
            <Global.Container>
              <div>
                <S.ListContainer>
                  <li>
                    <S.ListItemBlock>
                      <S.ListIconBlock>
                        <FaPhoneSquare size={24} />
                      </S.ListIconBlock>
                      <a
                        href="https://wa.me/8109064642904"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Txt.TextMd>+81 090 6464-2904</Txt.TextMd>
                      </a>
                    </S.ListItemBlock>
                  </li>
                  <li>
                    <S.ListItemBlock>
                      <S.ListIconBlock>
                        <FaMapMarkerAlt size={24} />
                      </S.ListIconBlock>
                      <a href={'https://maps.app.goo.gl/kypovNH4xEfZvdyV6'}>
                        <Txt.TextMd>
                          Teramae-33 Akashibucho, Okazaki, Aichi 444-0241, Japão
                        </Txt.TextMd>
                      </a>
                    </S.ListItemBlock>
                  </li>
                  <li>
                    <S.ListItemBlock>
                      <S.ListIconBlock>
                        <FaEnvelope size={24} />
                      </S.ListIconBlock>
                      <a href={`mailto:contato@cantinhodatiachechela.com`}>
                        <Txt.TextMd>
                          contato@cantinhodatiachechela.com
                        </Txt.TextMd>
                      </a>
                    </S.ListItemBlock>
                  </li>
                  <li>
                    <S.ListItemFlex>
                      <a
                        href="https://www.facebook.com/tiachechela"
                        className="flex-icon"
                      >
                        <S.ListSocialIcon>
                          <FaFacebook size={30} className="margin" />
                        </S.ListSocialIcon>
                      </a>
                      <a href="https://www.instagram.com/cantinhodatiachechela/">
                        <S.ListSocialIcon>
                          <FaInstagram size={30} />
                        </S.ListSocialIcon>
                      </a>
                    </S.ListItemFlex>
                  </li>
                </S.ListContainer>
              </div>
            </Global.Container>
          </S.Container>
        </Global.Container>
      </ConstruindoContainer>
    </>
  )
}

export default Construindo
